import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const hasSupabaseConfig = Boolean(
  url &&
    anonKey &&
    !url.includes("your-project-ref") &&
    !anonKey.includes("your-supabase-anon-key")
);

export const supabase = hasSupabaseConfig ? createClient(url, anonKey) : null;

export function createNoSessionSupabaseClient() {
  if (!hasSupabaseConfig) return null;
  return createClient(url, anonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false
    }
  });
}
